
import { mapGetters } from "vuex";
import { getCountry } from "@/components/Vuetify/utils";
export default {
    name: "Contact",
    data: () => ({
        api: "contactus",
        tel: "",
        mapReady: false,
        panelShow: 0,
        defaultCountry: "LA",
        generalInquiryValid: false,
        generalInquiryForm: {
            full_name: "",
            email: "",
            phone: "",
            subject_id: "",
            file_path: "",
            description: "",
        },
        whistleBlowerValid: false,
        whistleBlowerForm: {
            full_name: "",
            email: "",
            phone: "",
            subject_id: "",
            file_path: "",
            description: "",
        },

        clusterStyle: [
            {
                url: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m1.png",
                width: 56,
                height: 56,
                textColor: "#fff",
            },
        ],
    }),
    head: {
        title: "Contact",
        htmlAttrs: {
            lang: "en",
        },
        meta: [
            { charset: "utf-8" },
            {
                name: "viewport",
                content: "width=device-width, initial-scale=1",
            },
            {
                hid: "description",
                name: "description",
                content: `LOGC Contact page is supply any information that you can contact us easily and make sure that we are always welcome to recieve any response from all of you customer`,
            },
            { name: "format-detection", content: "telephone=no" },
        ],
    },
    computed: {
        ...mapGetters({
            loading: "contact/loading",
            information: "contact/information",
            faqs: "contact/faqs",
            generalInquirySubjects: "contact/generalInquirySubjects",
            whistleBlowerSubjects: "contact/whistleBlowerSubjects",
            inquiryLoading: "contact/inquiryLoading",
            blowerLoading: "contact/blowerLoading",
        }),
        formRule() {
            return {
                full_name: [
                    (v) => (!!v && !!v.trim()) || this.tl("fullNameRequired"),
                ],
                email: [
                    (v) => (!!v && !!v.trim()) || this.tl("emailRequired"),
                    (v) =>
                        !v ||
                        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                        this.tl("emailFormatInvalid"),
                ],
                subject_id: [
                    (v) => (!!v && !!v.trim()) || this.tl("subjectRequired"),
                ],
                description: [
                    (v) =>
                        (!!v && !!v.trim()) || this.tl("descriptionRequired"),
                ],
            };
        },
    },
    mounted() {
        this.$store.dispatch("contact/getContactUsInfo");
        this.$store.dispatch("contact/getFAQ");
        if (!this.generalInquirySubjects.length)
            this.$store.dispatch("contact/getGeneralInquirySubject");
        if (!this.whistleBlowerSubjects.length)
            this.$store.dispatch("contact/getWhistleBlowerSubject");
        this.mapReady = true;
        getCountry()
            .then((res) => {
                this.defaultCountry = res;
            })
            .catch(() => {
                this.defaultCountry = "LA";
            });
    },
    methods: {
        onGeneralInquiryValidChang(validObj) {
            if (validObj.valid) {
                this.generalInquiryForm.phone = validObj?.number?.e164;
            } else {
                this.generalInquiryForm.phone = "";
            }
        },
        onWhistleBlowerValidChang(validObj) {
            if (validObj.valid) {
                this.whistleBlowerForm.phone = validObj?.number?.e164;
            } else {
                this.whistleBlowerForm.phone = "";
            }
        },
        clearGeneralInquiryForm() {
            this.$refs.generalInquiry.reset();
            this.generalInquiryForm = {
                full_name: "",
                email: "",
                phone: "",
                subject_id: "",
                file_path: "",
                description: "",
            };
        },
        async doSubmitGeneralInquiry() {
            this.$refs.generalInquiry.validate();
            if (this.generalInquiryValid && this.generalInquiryForm.phone) {
                const response = await this.$store.dispatch(
                    "contact/doSubmitGeneralInquiry",
                    this.generalInquiryForm
                );
                if (response) {
                    this.clearGeneralInquiryForm();
                }
            }
        },
        clearWhistleBlowerForm() {
            this.$refs.whistleBlower.reset();
            this.whistleBlowerForm = {
                full_name: "",
                email: "",
                phone: "",
                subject_id: "",
                file_path: "",
                description: "",
            };
        },
        async doSubmitWhistleBlower() {
            this.$refs.whistleBlower.validate();
            if (this.whistleBlowerValid && this.whistleBlowerForm.phone) {
                const response = await this.$store.dispatch(
                    "contact/doSubmitWhistleBlower",
                    this.whistleBlowerForm
                );
                if (response) {
                    this.clearWhistleBlowerForm();
                }
            }
        },
    },
};
